export const UMB_PROPERTY_EDITOR_DATA_SOURCE_ENTITY_TYPE = 'property-editor-data-source';

export type UmbPropertyEditorDataSourceEntityType = typeof UMB_PROPERTY_EDITOR_DATA_SOURCE_ENTITY_TYPE;
